import React from "react";
import { Row, Col } from "antd";

import FiltersButton from "./filtersButton";
import ColumnsButton from "./columnsButton";
import SnapshotsButton from "./snapshotsButton";
import ExportButton from "./exportButton";
import DataButton from "./dataButton";
import Title from "./title";
import { Report } from "/app/src/models";
import PermissionIcons from "./permissionIcons";

/**
 * Renders the controls component with various buttons and titles.
 * @param {Object} props - The properties for the Controls component.
 * @param {Report} props.report - The report object used for displaying the title.
 * @param {number} props.columnsCount - The number of columns to display in the ColumnsButton.
 * @param {number} props.filtersCount - The number of filters to display in the FiltersButton.
 * @param {number} props.snapshotsCount - The number of snapshots to display in the SnapshotsButton.
 * @returns {JSX.Element} The rendered controls component.
 */
export default function Controls({
  report,
  columnsCount,
  filtersCount,
  snapshotsCount,
}: {
  report: Report;
  columnsCount: number;
  filtersCount: number;
  snapshotsCount: number;
}) {
  return (
    <div className="controls">
      <Row align="bottom">
        <Col>
          <Title report={report} />
        </Col>
        <Col flex="auto" className="controlTabs">
          <Row>
            <Col span={24} style={{ marginBottom: "15px" }}>
              <PermissionIcons />
            </Col>
            <Col span={24}>
              <FiltersButton filtersCount={filtersCount} />
              <ColumnsButton columnsCount={columnsCount} />
              <SnapshotsButton snapshotsCount={snapshotsCount} />
              <ExportButton />
              <DataButton />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
}
